// extracted by mini-css-extract-plugin
module.exports = {"vdoBox":"ShowVideo__vdoBox__BS1gF","videoBgStyle":"ShowVideo__videoBgStyle__3Ysxs"};